import { render } from "./UserProfile.vue?vue&type=template&id=3c06fe7e&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=3c06fe7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c06fe7e"

export default script